<template>
  <div
    class="form-group"
    :class="{
      'form-group--has-error': localError,
      'form-group--has-success': !localError && touched,
      [`form-group--size-${size}`]: true,
    }"
  >
    <!-- <label :for="id" v-if="label">{{ label }}</label> -->
    <input
      type="time"
      :id="id"
      :value="modelValue"
      :disabled="disabled"
      @input="handleInput"
      @blur="handleBlur"
      ref="inputRef"
    />
    <span v-if="localError" class="form-group__error">{{ localError }}</span>
  </div>
</template>

<script>
  import { ref, watch } from 'vue';
  import { validateInput } from '@/utils/validation';
  import { uid } from 'uid';

  export default {
    props: {
      id: {
        type: String,
        required: false,
        default: () => `time-${uid()}`,
      },
      label: {
        type: String,
        required: false,
        default: '',
      },
      modelValue: {
        type: String,
        required: true,
        default: '00:00',
      },
      error: {
        type: String,
        default: '',
      },
      rules: {
        type: Array,
        default: () => [],
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      size: {
        type: String,
        default: 'md',
      },
    },

    emits: ['update:modelValue', 'validate'],

    setup(props, { emit }) {
      const localError = ref(props.error);
      const touched = ref(false);

      const handleInput = (event) => {
        emit('update:modelValue', event.target.value);
      };

      const handleBlur = () => {
        touched.value = true;
        validate();
      };

      const validate = () => {
        const errorMessage = validateInput(props.modelValue, props.rules);
        localError.value = errorMessage;
        emit('validate', errorMessage);
      };

      watch(
        () => props.error,
        (newError) => {
          localError.value = newError;
        },
        { immediate: true }
      );

      return {
        handleInput,
        handleBlur,
        validate,
        localError,
        touched,
      };
    },
  };
</script>

<style scoped lang="scss">
  .form-group input[type='time']:disabled {
    background-color: #f5f5f5;
    cursor: not-allowed;
  }

  .form-group--has-error input[type='time'] {
    // border-color: #dc3545;
  }

  .form-group--has-success input[type='time'] {
    // border-color: #28a745;
  }
</style>
